import React from "react"
import { useTranslation } from "react-i18next"
import {
 AlertDialog,
 AlertDialogCancel,
 AlertDialogContent,
 AlertDialogDescription,
 AlertDialogFooter,
 AlertDialogHeader,
 AlertDialogTitle,
} from "./ui/alert-dialog"
import { Button } from "./ui/button"
interface ConfirmDialogProps {
 open: boolean
 onOpenChange: (open: boolean) => void
 title: string
 description: string
 confirmText?: string
 cancelText?: string
 onConfirm: () => void
 variant?:"primary"|"destructive"|"warning"
 loading?: boolean
}

export function ConfirmDialog({
 open,
 onOpenChange,
 title,
 description,
 confirmText,
 cancelText,
 onConfirm,
 variant ="primary",
 loading = false,
}: ConfirmDialogProps) {
 const { t, i18n } = useTranslation()
 const resolvedConfirmText = confirmText ?? t('ui.confirm')
 const resolvedCancelText = cancelText ?? t('ui.cancel')

 return (
 <AlertDialog open={open} onOpenChange={onOpenChange}>
 <AlertDialogContent dir={i18n.dir()}>
 <AlertDialogHeader>
 <AlertDialogTitle>{title}</AlertDialogTitle>
 <AlertDialogDescription>{description}</AlertDialogDescription>
 </AlertDialogHeader>
 <AlertDialogFooter>
 <AlertDialogCancel disabled={loading}>{resolvedCancelText}</AlertDialogCancel>
 <Button
 variant={variant === "destructive"? "destructive": variant === "warning"? "warning":"default"}
 onClick={onConfirm}
 disabled={loading}
 >
 {loading && (
 <svg className="me-2 h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
 <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
 <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
 </svg>
 )}
 {resolvedConfirmText}
 </Button>
 </AlertDialogFooter>
 </AlertDialogContent>
 </AlertDialog>
 )
}
